export interface ExportByEmailModalTranslations {
	title: string;
	description: string;
	emailLabel: string;
	emailPlaceholder: string;
	confirmButton: string;
	cancelButton: string;
}

export const EXPORT_BY_EMAIL_MODAL_PT_BR: ExportByEmailModalTranslations = {
	title: "Exportar relatório por email",
	description:
		"O período selecionado é maior que {{days}} dias. O relatório será gerado em segundo plano e enviado para o email informado.",
	emailLabel: "Email",
	emailPlaceholder: "exemplo@email.com",
	confirmButton: "Confirmar envio",
	cancelButton: "Cancelar",
};
